var _circle, _circle2, _circle3, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgDeleteVehicle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 151,
    viewBox: "0 0 153 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 76.5,
    cy: 75.5,
    r: 70,
    stroke: "#FFD4D6",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 76.5,
    cy: 75.5,
    r: 75,
    stroke: "#FFD4D6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 75.5,
    r: 63.5,
    stroke: "#FFD4D6",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 75C16 41.8629 42.8629 15 76 15C109.137 15 136 41.8629 136 75C136 108.137 109.137 135 76 135C42.8629 135 16 108.137 16 75Z",
    fill: "#F8696E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_882_33358)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_882_33358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.4229 41C85.9962 41 87.4571 41.9244 88.1876 43.3689L89.1429 45.3333H101.786C104.09 45.3333 106 47.2978 106 49.6667C106 52.0356 104.09 54 101.786 54H51.2143C48.9105 54 47 52.0356 47 49.6667C47 47.2978 48.9105 45.3333 51.2143 45.3333H63.8571L64.8124 43.3689C65.5429 41.9244 67.0038 41 68.5771 41H84.4229Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter1_d_882_33358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.3585 67.5487C91.3585 66.3641 90.3962 65.4051 89.2075 65.4051C88.0189 65.4051 87.0566 66.3641 87.0566 67.5487V93.1641C87.0566 94.3487 88.0189 95.3077 89.2075 95.3077C90.3962 95.3077 91.3585 94.3487 91.3585 93.1641V67.5487ZM78.6226 67.5487C78.6226 66.3641 77.6604 65.4051 76.4717 65.4051C75.283 65.4051 74.3208 66.3641 74.3208 67.5487V93.1641C74.3208 94.3487 75.283 95.3077 76.4717 95.3077C77.6604 95.3077 78.6226 94.3487 78.6226 93.1641V67.5487ZM65.8868 67.5487C65.8868 66.3641 64.9245 65.4051 63.7358 65.4051C62.5472 65.4051 61.5849 66.3641 61.5849 67.5487V93.1641C61.5849 94.3487 62.5472 95.3077 63.7358 95.3077C64.9245 95.3077 65.8868 94.3487 65.8868 93.1641V67.5487ZM102 99.5385C102 104.221 98.2075 108 93.5094 108H59.4906C54.7925 108 51 104.221 51 99.5385V57H101.943V99.5385H102Z",
    fill: "url(#paint0_linear_882_33358)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_882_33358",
    x: 23,
    y: 25,
    width: 107,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.924056 0 0 0 0 0.224592 0 0 0 0 0.249049 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_882_33358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_882_33358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_882_33358",
    x: 27,
    y: 41,
    width: 99,
    height: 99,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.924056 0 0 0 0 0.224592 0 0 0 0 0.249049 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_882_33358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_882_33358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_882_33358",
    x1: 76.5,
    y1: 57,
    x2: 76.5,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_882_33358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 92,
    fill: "white",
    transform: "translate(33 35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDeleteVehicle);
export default __webpack_public_path__ + "static/media/img_delete_vehicle.30f118610c455afb36f100985a964c2d.svg";
export { ForwardRef as ReactComponent };